import { render, staticRenderFns } from "./CreateGlassOption.vue?vue&type=template&id=f188e036&"
import script from "./CreateGlassOption.vue?vue&type=script&lang=js&"
export * from "./CreateGlassOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports